import { render } from "./Homepage_onlinejobs2.vue?vue&type=template&id=10f2a112"
import script from "./Homepage_onlinejobs2.vue?vue&type=script&lang=js"
export * from "./Homepage_onlinejobs2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__